// components/ResponsiveImage.tsx

export default function ResponsiveImage({avif, webp, srcFallback, eager, sizes="(max-width:768px) 100vw, 50vw", ...imgProps}) {
  return (
    <picture>
      {/* {avif && <source srcSet={avif} type="image/avif" />} */}
      {webp && <source srcSet={webp} type="image/webp" />}
      <img
        src={srcFallback}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={eager ? 'high' : 'auto'}  // Chrome hints for LCP
        sizes={sizes}
        {...imgProps}
      />
    </picture>
  );
}
